import { EffectCallback, useEffect } from "react";

export default function useRunOnce(effect: EffectCallback) {
  /* oxlint-disable react-hooks/exhaustive-deps -- intentionally run-once: the empty dependency array is
     the point of this hook, so callers can pass an inline, unmemoized effect. Adding `effect` here would
     defeat that and re-run on every render. */
  useEffect(effect, []);
  /* oxlint-enable react-hooks/exhaustive-deps */
}
